import { render, staticRenderFns } from "./IconMinusSmOutline.vue?vue&type=template&id=b94b17ea"
import script from "./IconMinusSmOutline.vue?vue&type=script&lang=js"
export * from "./IconMinusSmOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports